module.exports = __webpack_public_path__ + "static/media/Portada_management.eb68bde7.png";